import React from 'react';
import { Col, Form, Row } from 'antd';
import ProductSelector from '@/components/selector/product-finder-selector';
import { IProduct } from '@/interfaces/product';

interface IProps {
  onSelectProduct: (data: IProduct) => void;
}

const InboundProductFinderTab = ({ onSelectProduct }: IProps) => {
  return (
    <div className="flex w-full">
      <Row gutter={12}>
        <Col span={24}>
          <div className="flex w-full flex-row items-end gap-3">
            <div className="flex">
              <Form.Item label="" name="">
                <ProductSelector
                  handleSelectData={product => {
                    onSelectProduct(product);
                  }}
                  size="large"
                />
              </Form.Item>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default InboundProductFinderTab;
